import { HumanTaskIsRequiredBlockFormField } from './lib/IsRequiredField';
import { type HumanTaskBlockFormFieldsProps } from './types';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';

export function HumanTaskEditableValueBlockFormFields(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <>
      <BlockValueTemplateField label="Field label" fieldName={`${fieldNamePrefix}.label`} />
      <BlockValueTemplateField
        label="Variable name"
        fieldName={`${fieldNamePrefix}.variableName`}
      />
      <BlockValueTemplateField label="Inbound data" fieldName={`${fieldNamePrefix}.initialValue`} />
      <HumanTaskIsRequiredBlockFormField fieldNamePrefix={fieldNamePrefix} />
    </>
  );
}
